import { TFunction } from '@lyearn/i18n';

import { AutoAssignEnum } from './types';

export const getAutoAssignMenu = (t: TFunction) => [
  {
    id: AutoAssignEnum.OnSpecificDate,
    label: t('AssignmentCreator:OnSpecificDate'),
  },
  {
    id: AutoAssignEnum.Never,
    label: t('AssignmentCreator:Never'),
  },
];
